
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/login/Login';
// import Profile from './components/Profile';
import Index from './components/Index';
import LoyaltyReport from './components/LoyaltyReport';
import Voucher from './components/voucher/Voucher';
import FaceDetect from './components/FaceDetect';
import Customer from './components/customer/Customer';
import Store from './components/store/Store';
import LoyaltyCard from './components/loyalty/LoyaltyCard';
import LoyaltyUserCard from './components/loyalty/LoyaltyUserCard';
import LoyaltyUserCardOnlyPrint from './components/loyalty/LoyaltyUserCardOnlyPrint';
import LoyaltyUserCardPrint from './components/loyalty/LoyaltyUserCardPrint';
import LoyaltyRewards from './components/loyalty/LoyaltyRewards';
import LoyaltyRedemption from './components/loyalty/LoyaltyRedemption';
import AddStore from './components/store/AddStore';
import PrivateRoute from './components/PrivateRoute';
import StoreReports from './components/report/StoreReports';
import CustomerReports from './components/report/CustomerReports';
import RewardReports from './components/report/RewardReports';
import Earningbycustomer from './components/report/Earningbycustomer';
import Error from './Error';
import Layout from "./components/Layout";
import ProductDetails from './components/products/ProductDetails';
import Order from './components/products/Order';
import Products from './components/products/Products';
import Membership from './components/membership/Membership';
import Landing from './components/web/Landing';
import StoreDetailPage from './components/web/StoreDetailPage';
import StorePayment from './components/web/payment/StorePayment';
import MembershipPage from './components/web/MembershipPage';
import Confirmation from './components/web/payment/Confirmation';
import RewardLedger from './components/rewardLedger/RewardLedger';
import RewardLedgerPending from './components/rewardLedger/RewardLedgerPending';
import MyVouchers from './components/web/MyVouchers';
import RedeemHistory from './components/web/RedeemHistory';
import MembershipInvites from './components/membership/MembershipInvites';
import StorePanelLayout from './components/storePanel/StorePanelLayout';
import StorePanelHome from './components/storePanel/StorePanelHome';
import StorePanelPrivateRoute from './components/storePanel/StorePanelPrivateRoute';
import ReferAndEarn from './components/web/ReferAndEarn';
import StoreLogin from './components/storePanel/login/StoreLogin';
import VoucherApprovals from './components/voucher/VoucherApprovals';
import StoreBillScan from './components/web/StoreBillScan';
import StorePanelBillQR from './components/storePanel/StorePanelBillQR';
import PaidMembersByTier from './components/report/PaidMembersByTier';
import RegisteredMembers from './components/report/RegisteredMembers';
import ActivationRate from './components/report/ActivationRate';
import ActiveTransactors from './components/report/ActiveTransactors';
import CommissionReport from './components/report/CommissionReport';
import StorePanelQR from './components/storePanel/StorePanelQR';
import StorePayByQR from './components/web/StorePayByQR';

function App() {
  return (

    <BrowserRouter>
      <AuthProvider>
        {/* <Layout> */}
          <Routes>
            {/* Store panel: its own layout, NOT inside admin Layout */}
          <Route path="/store-login" element={<StoreLogin />} />
          <Route path="/store-panel" element={<StorePanelPrivateRoute><StorePanelLayout /></StorePanelPrivateRoute>}>
            <Route index element={<StorePanelHome />} />
            <Route path="/store-panel/reward-pending-ledger" element={<RewardLedgerPending />} />
            <Route path="/store-panel/voucher" element={<Voucher />} />
            <Route path="/store-panel/reward" element={<LoyaltyRewards />} />
            <Route path="create-bill" element={<StorePanelBillQR />} />
            <Route path="profile" element={<AddStore key="profile" mode="store" />} />
            <Route path="qr" element={<StorePanelQR />} />
            {/* add more store panel pages here */}
          </Route>
            <Route
            path="*"
            element={
              <Layout>
                <Routes>
                   <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Index />
                </PrivateRoute>
              }
            />
            <Route path="/customer" element={<PrivateRoute>  <Customer /> </PrivateRoute>} />
            <Route path="/store" element={<PrivateRoute>  <Store /> </PrivateRoute>} />
            <Route path="/store/add" element={<PrivateRoute> <AddStore key="add" /> </PrivateRoute>} />
            <Route path="/store/edit" element={<PrivateRoute> <AddStore key="edit" /> </PrivateRoute>} />
            <Route path="/loyalty/membership" element={<PrivateRoute>  <Membership /> </PrivateRoute>} />
            <Route path="/loyalty/membership/invites" element={<PrivateRoute>  <MembershipInvites /> </PrivateRoute>} />
            <Route path="/loyalty/loyalty_card" element={<PrivateRoute>  <LoyaltyCard /> </PrivateRoute>} />
            <Route path="/loyalty/customer_card" element={<PrivateRoute>  <LoyaltyUserCard /> </PrivateRoute>} />
            <Route path="/loyalty/reward" element={<PrivateRoute>  <LoyaltyRewards /> </PrivateRoute>} />
            <Route path="/loyalty/redemption" element={<PrivateRoute>  <LoyaltyRedemption /> </PrivateRoute>} />
            <Route path="/loyalty/printcards" element={<PrivateRoute>  <LoyaltyUserCardOnlyPrint /> </PrivateRoute>} />
            <Route path="/loyalty/printcard" element={<PrivateRoute>  <LoyaltyUserCardPrint /> </PrivateRoute>} />
            <Route path="/loyalty/reward-ledger" element={<PrivateRoute>  <RewardLedger /> </PrivateRoute>} />
            <Route path="/loyalty/reward-pending-ledger" element={<PrivateRoute>  <RewardLedgerPending /> </PrivateRoute>} />
            <Route path="/report">
              <Route index element={<PrivateRoute>  <LoyaltyReport /> </PrivateRoute>} />
              <Route path="store" element={<PrivateRoute>  <StoreReports /> </PrivateRoute>} />
              <Route path="customer" element={<PrivateRoute>  <CustomerReports /> </PrivateRoute>} />
              <Route path="reward" element={<PrivateRoute>  <RewardReports /> </PrivateRoute>} />
              <Route path="earningbycustomer" element={<PrivateRoute>  <Earningbycustomer /> </PrivateRoute>} />
              <Route path="paidmembers" element={<PrivateRoute>  <PaidMembersByTier /> </PrivateRoute>} />
              <Route path="registeredmembers" element={<PrivateRoute>  <RegisteredMembers /> </PrivateRoute>} />
              <Route path="activation" element={<PrivateRoute>  <ActivationRate /> </PrivateRoute>} />
              <Route path="activetransactors" element={<PrivateRoute>  <ActiveTransactors /> </PrivateRoute>} />
              <Route path="commission" element={<PrivateRoute>  <CommissionReport /> </PrivateRoute>} />
            </Route>
            <Route path="/voucher">
              <Route index element={<PrivateRoute>  <Voucher /> </PrivateRoute>} />
              <Route path="approvals" element={<PrivateRoute>  <VoucherApprovals /> </PrivateRoute>} />
            </Route>
            <Route path="/products">
              <Route index element={<PrivateRoute>  <Products /> </PrivateRoute>} />
              <Route path="details/:id" element={<PrivateRoute>  <ProductDetails /> </PrivateRoute>} />
              <Route path="order" element={<PrivateRoute>  <Order /> </PrivateRoute>} />
            </Route>
            <Route path="/facedetect" element={<PrivateRoute>  <FaceDetect /> </PrivateRoute>} />

            {/* goerone web for testing */}
            <Route path="/web/home" element={ <Landing />} />
            <Route path="/web/store-details" element={<PrivateRoute>  <StoreDetailPage /> </PrivateRoute>} />
            <Route path="/web/store-payment" element={<PrivateRoute> <StorePayment /> </PrivateRoute>} />
            <Route path="/web/membership" element={<PrivateRoute> <MembershipPage /> </PrivateRoute>} />
            <Route path="/web/payment-confirmation" element={<PrivateRoute> <Confirmation /> </PrivateRoute>} />
            <Route path="/web/my-vouchers" element={<PrivateRoute> <MyVouchers /> </PrivateRoute>} />
            <Route path="/web/redeem-history" element={<PrivateRoute><RedeemHistory /></PrivateRoute>} />
            <Route path="/web/refer-and-earn" element={<PrivateRoute><ReferAndEarn /></PrivateRoute>} />
            <Route path="/web/store-bill" element={<PrivateRoute><StoreBillScan /></PrivateRoute>} />
            <Route path="/web/pay/:handle" element={<PrivateRoute><StorePayByQR /></PrivateRoute>} />
            {/* till here */}
            
            <Route path="*" element={<Error />} />
                </Routes>
              </Layout>
            }
          />
           
          </Routes>
        {/* </Layout> */}
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
